import endpoints from '@/constants/endpoints';
import axiosV2 from '../axiosv2';

export const passwordResetRequest = async (email: string): Promise<void> => {
  const endpoint = endpoints.seller.passwordReset;
  return await axiosV2.post(endpoint, { email });
};
